module.exports = __webpack_public_path__ + "img/Wema Bank.a6e67836.png";